import styled from 'styled-components';

export const MainScreenStyle = styled.section`
    width: 100%;
    display: flex;
    flex-direction:column;
    align-items:center;
    justify-content:space-between;
    padding: 0 1rem;
    padding-top:2.1rem;

`